import { __decorate, __extends, __spreadArrays } from "tslib";
import NavPanel from '@/components/common/NavPanel.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/invite/import';
import AvalonGTGlobal from '@/utils/factory/Global';
var HuanxunIncomeReport = /** @class */ (function (_super) {
    __extends(HuanxunIncomeReport, _super);
    function HuanxunIncomeReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportList = [];
        _this.loading = true;
        _this.finished = false;
        _this.pageIndex = 1;
        _this.params = {};
        _this.enableBtn = false;
        _this.downloadUrl = '';
        _this.syncingScroll = false;
        return _this;
    }
    HuanxunIncomeReport.prototype.mounted = function () {
        this.params = this.$route.query;
        this.getList();
        this.getDownloadUrl();
    };
    HuanxunIncomeReport.prototype.onIndexScroll = function () {
        if (this.syncingScroll)
            return;
        var indexBd = this.$refs.indexBd;
        var listBd = this.$refs.listBd;
        if (!indexBd || !listBd)
            return;
        this.syncingScroll = true;
        listBd.scrollTop = indexBd.scrollTop;
        this.syncingScroll = false;
    };
    HuanxunIncomeReport.prototype.onListScroll = function () {
        if (this.syncingScroll)
            return;
        var indexBd = this.$refs.indexBd;
        var listBd = this.$refs.listBd;
        if (!indexBd || !listBd)
            return;
        this.syncingScroll = true;
        indexBd.scrollTop = listBd.scrollTop;
        this.syncingScroll = false;
    };
    HuanxunIncomeReport.prototype.onLoad = function () {
        this.loading = true;
        this.finished = false;
        this.pageIndex++;
        this.getList();
    };
    HuanxunIncomeReport.prototype.getList = function () {
        var _this = this;
        PageService.inviteRewardDetailRecord({
            page: this.pageIndex,
            day: this.params.date,
        }).then(function (data) {
            if (_this.pageIndex == 1) {
                _this.enableBtn = Number(data.enable) == 1;
            }
            if (data.list) {
                if (data.list.length != 0 && _this.pageIndex != 1) {
                    _this.reportList = __spreadArrays(_this.reportList, data.list);
                }
                else if (data.list.length != 0 && _this.pageIndex == 1) {
                    _this.reportList = data.list;
                }
                else {
                    _this.finished = true;
                }
                _this.loading = false;
            }
            else {
                if (_this.pageIndex == 1) {
                    _this.reportList = [];
                }
                _this.finished = true;
                _this.loading = false;
            }
        });
    };
    HuanxunIncomeReport.prototype.getDownloadUrl = function () {
        var _this = this;
        PageService.exportInviteExcel({
            day: this.params.date,
        }).then(function (data) {
            _this.downloadUrl = data.url;
        });
    };
    HuanxunIncomeReport.prototype.exportExcel = function () {
        AvalonGTGlobal.copyText(this.downloadUrl.toString(), '快去浏览器下载吧');
    };
    HuanxunIncomeReport = __decorate([
        Options({
            name: 'HuanxunIncomeReport',
            components: { NavPanel: NavPanel },
        })
    ], HuanxunIncomeReport);
    return HuanxunIncomeReport;
}(AvalonGTView.BaseView));
export default HuanxunIncomeReport;
